import React, { SVGProps } from 'react';

const SvgTaskMonitoring = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
            <path d="M11.4211 2.4632H14.9579C16.3728 2.4632 17.0802 2.4632 17.6206 2.73855C18.096 2.98076 18.4824 3.36723 18.7246 3.84259C19 4.383 19 5.09043 19 6.5053V13.579C19 14.9939 19 15.7013 18.7246 16.2417C18.4824 16.7171 18.096 17.1035 17.6206 17.3457C17.0802 17.6211 16.3728 17.6211 14.9579 17.6211H7.88421C6.46934 17.6211 5.7619 17.6211 5.2215 17.3457C4.74614 17.1035 4.35966 16.7171 4.11746 16.2417C3.84211 15.7013 3.84211 14.9939 3.84211 13.579V10.0421M8.05263 10.8843V14.2527M14.7895 9.20004V14.2527M11.4211 5.83162V14.2527M5.52632 6.67373V1.62109M3 4.14741H8.05263" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

export default SvgTaskMonitoring;